import React from "react";
import {
  Box,
  Button,
  Collapse,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FtiBilingualText } from "./FtiBilingualText";

const headerCellSx = { bgcolor: "#F5F5F5", fontWeight: 600, py: "10px" };

// Every reprint issues a replacement copy, the latest one is summarised in the header
export const FtiReprintHistory = ({ reprints }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const latestReprint = reprints[reprints.length - 1];

  return (
    <Paper sx={{ overflow: "hidden" }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap="16px"
        sx={{ pl: "24px" }}
      >
        <Typography variant="subtitle2" fontWeight={500} sx={{ py: "14px" }}>
          Remarks/หมายเหตุ: {latestReprint.remark}
        </Typography>
        <Button
          onClick={() => setIsOpen(!isOpen)}
          endIcon={isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          sx={{
            alignSelf: "stretch",
            borderRadius: 0,
            px: "16px",
            bgcolor: "#E8F0FA",
            whiteSpace: "nowrap",
          }}
        >
          Reprint History/ประวัติการพิมพ์ซ้ำ
        </Button>
      </Stack>
      <Collapse in={isOpen}>
        <Box sx={{ p: "8px 24px 16px", borderTop: "1px solid #E6E6E6" }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={headerCellSx}>Re-print/พิมพ์ซ้ำ</TableCell>
                  <TableCell sx={headerCellSx}>
                    Reprint Date/วันที่พิมพ์ซ้ำ
                  </TableCell>
                  <TableCell sx={headerCellSx}>Remarks/หมายเหตุ</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reprints.map((reprint, index) => (
                  <TableRow key={reprint.id ?? index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      {reprint.re_print_date ? (
                        <FtiBilingualText
                          en={reprint.re_print_date}
                          th={reprint.display_re_print_date}
                        />
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell>{reprint.remark ?? "--"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Collapse>
    </Paper>
  );
};
